import View from './view';
import {target} from '../utils/dom';

function valid(el, input) {
	el.classList.remove('invalid');
}

function invalid(el, input) {
	el.classList.add('invalid');
}

const buttonSelector = '.slx-survey__button';

class Survey extends View {
	constructor(options) {
		super(options);
		this.buttons = [];
	}

	start() {
		super.start();
		this.initButtons(this.el);
	}

	onClick(ev) {
		let el = this;
		let inputid = el.dataset.inputid;
		let value = el.dataset.value;

		for (const but of document.querySelectorAll(buttonSelector)) {
			if (but.dataset.inputid === inputid) {
				but.classList.remove('active');
			}
		}
		el.classList.add('active');

		let input = document.getElementById(inputid);
		input.value = value;
	}

	initButtons(container) {
		for (const el of container.querySelectorAll(buttonSelector)) {
			this.initButton(el);
			this.buttons.push(el);
		}
	}

	initButton(el) {
		el.addEventListener('click', this.onClick, this);
	}
}

const surveys = document.querySelectorAll('.slx-form');
for (const elt of surveys) {
	new Survey({el: elt}).start();
}
